import React, { ReactElement } from 'react';
import { Skeleton, Row, Col, Card } from 'antd';
import { GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import './DoctorCardLoader.less';

const DoctorCardLoader = ({ col }: any): ReactElement => {
  const num_of_cards = [
    { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 },
  ];

  return (
    <>
      <Row gutter={GUTTOR_SPACE} >
        {num_of_cards === null ? '' :
          num_of_cards.map((item: any): any =>
            <Col key={item.id} md={col || 8}>
              <Card key={item.id} className="card-loader">
                <Skeleton active={true} avatar={{ shape: 'circle', size: 60 }} paragraph={{ rows: 3, width: 100 }} />
              </Card>
            </Col>,
          )
        };
      </Row>,
    </>
  );
};

export default DoctorCardLoader;
